import React, { useMemo } from 'react';
import { useFocusIdx } from 'easy-email-editor';
import { SelectField } from '../../../components/Form';

const options = [
  {
    value: '',
    label: 'Нет',
  },
  {
    value: 'underline',
    label: 'Подчеркнуть',
  },
  {
    value: 'overline',
    label: 'Надчеркивание',
  },
  {
    value: 'line-through',
    label: 'Линия, проходящая через',
  },
  {
    value: 'blink',
    label: 'Мигающий',
  },
  {
    value: 'inherit',
    label: 'Унаследовать',
  },
];

export function TextDecoration({ name }: { name?: string; }) {
  const { focusIdx } = useFocusIdx();

  return useMemo(() => {
    return (
      <SelectField
        label='Оформление текста'
        name={name || `${focusIdx}.attributes.text-decoration`}
        options={options}
      />
    );
  }, [focusIdx, name]);
}
